/* eslint-disable prettier/prettier */
/* eslint-disable */

import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Icon from "@mui/material/Icon";
import MuiLink from "@mui/material/Link";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import MKTypography from "components/MKTypography";

function FilledInfoCard({ variant, color, icon, title, description, action, isBooking }) {
  const buttonStyles = {
    width: "max-content",
    display: "flex",
    alignItems: "center",

    "& .material-icons-round": {
      fontSize: "1.125rem",
      transform: `translateX(3px)`,
      transition: "transform 0.2s cubic-bezier(0.34, 1.61, 0.7, 1.3)",
    },

    "&:hover .material-icons-round, &:focus .material-icons-round": {
      transform: `translateX(6px)`,
    },
  };

  let iconColor = color;

  if (variant === "gradient" && color !== "light") {
    iconColor = "white";
  } else if (variant === "gradient" && color === "light") {
    iconColor = "dark";
  }

  const cardContent = (
    <CardContent sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <MKTypography variant="h3" color={iconColor} textGradient={variant === "contained"} sx={{ mb: 1 }}>
        {typeof icon === "string" ? <Icon>{icon}</Icon> : icon}
      </MKTypography>

      <MKTypography
        variant="h5"
        color={variant === "contained" || color === "light" ? "dark" : "white"}
        fontWeight="bold"
        mb={1}
      >
        {title}
      </MKTypography>
      <MKTypography variant="body2" color={variant === "contained" || color === "light" ? "text" : "white"} mb={2}>
        {description}
      </MKTypography>

      {action && (
        <MKTypography
          variant="body2"
          fontWeight="regular"
          color={variant === "contained" ? color : "white"}
          sx={buttonStyles}
        >
          {action.label} <Icon sx={{ fontWeight: "bold" }}>arrow_forward</Icon>
        </MKTypography>
      )}
    </CardContent>
  );

  const CardWrapper = action ? (action.type === "internal" ? Link : MuiLink) : "div";
  
  return isBooking ? (
    <Link to="/kontakt-oss?type=generelt" style={{ textDecoration: "none" }}>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "xl",
          padding: 3,
          height: "100%",
          minHeight: "250px", // Sikrer at alle kort har en minimumshøyde
          bgcolor: "#3a82d1",
          "&:hover": {
            backgroundColor: "#2a72b8",
          },
        }}
      >
        {cardContent}
      </Card>
    </Link>
  ) : (
    <CardWrapper
      to={action && action.type === "internal" ? action.route : undefined}
      href={action && action.type === "external" ? action.route : undefined}
      target={action && action.type === "external" ? "_blank" : undefined}
      rel={action && action.type === "external" ? "noreferrer" : undefined}
      style={{ textDecoration: "none", display: "flex", flexDirection: "column", height: "100%" }}
    >
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "xl",
          padding: 3,
          height: "100%",
          minHeight: "250px", // Ensurerer at kortene ikke blir for små
          bgcolor: variant === "contained" ? "grey.100" : color,
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.6)",
          },
        }}
      >
        {cardContent}
      </Card>
    </CardWrapper>
  );
}

FilledInfoCard.defaultProps = {
  variant: "contained",
  color: "#3a82d1",
  action: null,
  isBooking: false,
};

FilledInfoCard.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
    PropTypes.string,
  ]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      type: PropTypes.oneOf(["external", "internal"]).isRequired,
      route: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ]),
  isBooking: PropTypes.bool,
};

export default FilledInfoCard;
